// ---------------- create a context to manage what is fullscreen -------------------
// ----------------------------------------------------------------------------------

import React, { createContext, useContext, useState } from 'react';

const FullscreenContext = createContext();

// provider component to manage which panel is in fullscreen mode and the height of the header
// header height is used to adjust the height of the fullscreen panel so that it does not overlap with the header
export const FullscreenProvider = ({ children }) => {

  // create state variables 
  const [fullscreenPanel, setFullscreenPanel] = useState(null); // shows which panel is in fullscreen mode, null means no panel is in fullscreen mode
  const [headerHeight, setHeaderHeight] = useState(70); // default header height is 70px, can be adjusted if the header height changes

  // function to toggle fullscreen mode for a panel
  const toggleFullscreen = (id) => {
    setFullscreenPanel(
      prev => {
        if (prev === id) {
          return null;
        } else {
          return id;
        }
      }
    ); // if the panel is fullscreen set it to null
  };

  // provide the context values to the children components
  return (
    <FullscreenContext.Provider value={{ fullscreenPanel, toggleFullscreen, headerHeight, setHeaderHeight }}>
      {children}
    </FullscreenContext.Provider>
  );
};

// custom hook to use the fullscreen context in other components
export const useFullscreen = () => useContext(FullscreenContext);
